import CreateQuestions from './CreateQuestions'

export default CreateQuestions;